import React, { useEffect, useState } from "react";
import { useHasWelcomeBackToPrimeBeenShown } from "clientState/useHasWelcomeBackToPrimeBeenShown/useHasWelcomeBackToPrimeBeenShown";
import usePrimeSiteProperties from "clientState/usePrimeSiteProperties/usePrimeSiteProperties";
import { useUser } from "clientState/useUser";
import { MEMBERSHIP_STATUS } from "clientState/useUser/membershipStatus";
import { useIsNative } from "@edreamsodigeo/frontend-core";

import WelcomeBackToPrimePopup from "../WelcomeBackToPrimePopup/WelcomeBackToPrimePopup";

const COOKIES_NOT_ACCEPTED_FALLBACK_VALUE = "not accepted";

const haveMoreThan24HoursPassed = (dateString: string): boolean => {
  const lastShownDate = new Date(dateString);
  const currentDate = new Date();
  const differenceInHours =
    (currentDate.getTime() - lastShownDate.getTime()) / (1000 * 60 * 60);

  return differenceInHours >= 24;
};

const WelcomeBackToPrimeManager: React.FC = () => {
  const [shouldDisplayComponent, setShouldDisplayComponent] = useState(false);
  const [welcomeBackToPrimeLastShownDate, setWelcomeBackToPrimeLastShownDate] =
    useHasWelcomeBackToPrimeBeenShown(
      /* eslint-disable  @typescript-eslint/no-explicit-any */
      COOKIES_NOT_ACCEPTED_FALLBACK_VALUE as any,
    );
  const hasUserAcceptedCookies =
    welcomeBackToPrimeLastShownDate !== COOKIES_NOT_ACCEPTED_FALLBACK_VALUE;

  const { user } = useUser(true);
  const isLoggedIn = !!user.email;
  const isMembership = user.membership?.status === MEMBERSHIP_STATUS.activated;
  const isPendingToCollect =
    user?.membership?.status === MEMBERSHIP_STATUS.pendingToCollect;
  const isNative = useIsNative();
  const { data: primeSitePropertiesData } = usePrimeSiteProperties();
  const isPrimeSite =
    primeSitePropertiesData?.primeSiteProperties.activePrimeMarket.flights ??
    false;

  const shouldWelcomeBackToPrimePopupBeShown =
    hasUserAcceptedCookies &&
    isLoggedIn &&
    isMembership &&
    isPrimeSite &&
    !isPendingToCollect &&
    !isNative;

  useEffect(() => {
    if (!shouldWelcomeBackToPrimePopupBeShown) {
      return;
    } else if (
      welcomeBackToPrimeLastShownDate === null ||
      (typeof welcomeBackToPrimeLastShownDate === "string" &&
        haveMoreThan24HoursPassed(welcomeBackToPrimeLastShownDate))
    ) {
      setTimeout(() => {
        setWelcomeBackToPrimeLastShownDate(new Date().toISOString());
        setShouldDisplayComponent(true);
      }, 1000);
    }
  }, [
    setShouldDisplayComponent,
    setWelcomeBackToPrimeLastShownDate,
    shouldWelcomeBackToPrimePopupBeShown,
    welcomeBackToPrimeLastShownDate,
  ]);

  return shouldDisplayComponent && shouldWelcomeBackToPrimePopupBeShown ? (
    <WelcomeBackToPrimePopup />
  ) : null;
};

export default WelcomeBackToPrimeManager;
